export default function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="glass-header sticky top-0 z-20">
      <div className="px-8 lg:px-12 py-6 flex items-start justify-between gap-4">
        <div className="min-w-0">
          {eyebrow && <div className="hbt-label mb-2" data-testid="page-eyebrow">{eyebrow}</div>}
          <h1 className="font-display text-3xl lg:text-4xl tracking-tight font-semibold leading-none" data-testid="page-title">{title}</h1>
          {subtitle && <p className="text-sm text-neutral-500 mt-2 max-w-2xl">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
      <div className="divider" />
    </div>
  );
}
